export default [
  {
    title: 'Home',
    route: 'home',
    icon: 'HomeIcon',
  },
  {
    title: 'Atendimento',
    route: 'atendimento',
    icon: 'MessageSquareIcon',
  },
  {
    title: 'Cadastros',
    icon: 'PlusSquareIcon',

    children: [
      {
        title: 'Usuários',
        route: 'list-users',

      },
      {
        title: 'Tipos de Unidade',
        route: 'list-tipo_unidades',

      },
      {
        title: 'Unidades',
        route: 'list-unidades',

      },
      {
        title: 'Grupos',
        route: 'list-grupos',

      },
    ]
  },
  {
    title: 'Dispositivos',
    route: 'list-devices',
    icon: 'MonitorIcon',
  },
  // {
  //   title: 'Dispositivos',
  //   icon: 'MonitorIcon',

  //   children: [
  //     {
  //       title: 'Dispositivos',
  //       route: 'list-devices',

  //     },
  //     {
  //       title: 'Comandos',
  //       route: 'list-comandos',

  //     },
  //   ]
  // },
  {
    title: 'WhatsApp',
    icon: 'SmartphoneIcon',

    children: [
      {
        title: 'Departamentos',
        route: 'list-departamentos',
      },
      {
        title: 'Contatos',
        route: 'list-contatos',
      },
      {
        title: 'Respostas Rápidas',
        route: 'list-respostas_rapidas',
      },
      {
        title: 'Modelos de Mensagem',
        route: 'list-modelos_mensagem',
      },
      {
        title: 'Fluxos (URA)',
        route: 'list-fluxos',
      },
    ]
  }
]
